/* Bundles & sets shelf (20 Oct 2026). Markup + CSS: sections/tc-set-shelf.liquid.
 * Tabs (WAI-ARIA, roving tabindex) fetch their cards once, on first open or on hover/touch/focus.
 * A set with 2-6 sizes gets size pills from its card's data-tc-size-data (core size picked: 300,
 * 250, 500 ml, else the lowest-priced in stock), price and "Save £x" per size, and one Add to cart
 * carrying [data-quick-add] for cart.js. Nothing moves by itself. Analytics: 'tc:shelf', consented.
 * v3 (20 Oct 2026): the photo follows the size. Each size's own photo comes from the card's
 * <script data-tss-img> (snippets/tc-set-shelf-card.liquid); picking a size swaps the photo, its
 * webp source and the card's links (?variant=). Only sizes in stock get a pill (no dead ends), and
 * the card's "Save £a–£b" range badge gives way to the picked size's "Save £x" by the price. */
(function () {
  'use strict';
  var TC = (window.TheColor = window.TheColor || {});
  if (TC.SetShelf) return;
  var cache = {}, pending = null;
  function $$(r, s) { return [].slice.call(r.querySelectorAll(s)); }
  function emit(d) {
    if (/(?:^|; )tc_cookie_consent=accepted(?:;|$)/.test(document.cookie)) try { document.dispatchEvent(new CustomEvent('tc:shelf', { detail: d })); } catch (e) {}
  }
  /* Size pills in one style (v2, 20 Oct 2026): "59 ml + 75 ml",
     "200 ml + 1 litre", "2 × 150 ml", "300 ml". */
  function short(t) {
    return String(t || '').replace(/\s+/g, ' ').trim()
      .replace(/(\d)\s?ml\b/gi, '$1 ml')
      .replace(/\b1000 ml\b/gi, '1 litre')
      .replace(/\b1\s?(?:l|ltr|liter|litre)\b/gi, '1 litre')
      .replace(/(\d)\s?[x\u00d7]\s?(?=\d)/g, '$1 \u00d7 ');
  }
  /* The sizes in a variant title, in ml: "2 × 150 ml" → [150, 150]. */
  function mls(t) {
    var out = [];
    short(t).toLowerCase().split('+').forEach(function (part) {
      var m = part.match(/(?:(\d+) \u00d7 )?(\d+(?:\.\d+)?) ?(ml|litres?)/);
      if (!m) return;
      for (var i = 0, n = +(m[1] || 1), v = parseFloat(m[2]) * (/^litre/.test(m[3]) ? 1000 : 1); i < n; i++) out.push(v);
    });
    return out;
  }
  function el(tag, cls, txt) { var e = document.createElement(tag); e.className = cls; if (txt) e.textContent = txt; return e; }
  /* "//…/x.jpg?v=1&width=500" → the same photo at width n (webp when asked). */
  function at(u, n, webp) { return u.replace(/([?&])width=\d+/, '$1width=' + n) + (webp ? '&format=webp' : ''); }
  function set(u, webp) { return [300, 500, 700].map(function (n) { return at(u, n, webp) + ' ' + n + 'w'; }).join(', '); }
  function base(u) { return String(u || '').split('?')[0].replace(/^https?:/, ''); }

  function enhance(card) {
    if (card.__tss) return;
    card.__tss = 1;
    var q = function (s) { return card.querySelector(s); }, data = q('script[data-tc-size-data]'), choose = q('[data-tc-size-picker]');
    var price = q('.tc-product-card__price-current'), buy = q('.tc-product-card__buy'), d, pics = {};
    if (!data || !choose || !price || !buy) return;
    try { d = JSON.parse(data.textContent); } catch (e) { return; }
    var pj = card.parentNode && card.parentNode.querySelector('script[data-tss-img]');
    if (pj) try { pics = JSON.parse(pj.textContent) || {}; } catch (e) {}
    var all = (d.v || []).filter(function (v) { return v && v.i; });
    /* In stock only (v3): a size that can't be bought from stock gets no pill. */
    var vs = all.filter(function (v) { return v.a && v.s !== false; }).sort(function (a, b) { return a.p - b.p; });
    var ok = vs, cur;
    if (all.length < 2 || all.length > 6 || !ok.length) return;
    var media = q('.tc-product-card__media'), titleA = q('.tc-product-card__title a');
    var pic = q('.tc-product-card__image-wrap > picture:not(.tc-product-card__hover-pic)');
    var img = pic && pic.querySelector('img'), src = pic && pic.querySelector('source[type="image/webp"]');
    var first = img ? [img.getAttribute('src'), img.getAttribute('width'), img.getAttribute('height'), img.getAttribute('alt')] : null;
    function photo(v) {
      var x = pics[v.i] || first;
      if (!img || !x || !x[0]) return;
      if (base(img.getAttribute('src')) !== base(x[0])) {
        if (img.complete && img.naturalWidth) { img.classList.add('tss__img--swap'); img.addEventListener('load', function off() { img.classList.remove('tss__img--swap'); img.removeEventListener('load', off); }); }
        if (src) src.setAttribute('srcset', set(x[0], 1));
        img.setAttribute('srcset', set(x[0]));
        img.setAttribute('src', at(x[0], 500));
        if (x[1]) img.setAttribute('width', x[1]);
        if (x[2]) img.setAttribute('height', x[2]);
      }
      if (x[3]) img.setAttribute('alt', x[3]);
    }
    card.classList.add('tss-has-sizes');
    /* Core size (v2): a single 300, 250 or 500 ml; else, for pairs, the
       lowest-priced in-stock size with no travel bottle (100 ml or less) and no
       litre in it (e.g. "200 ml + 250 ml", "2 × 150 ml"); else the lowest-priced
       in stock. */
    /* 27 Oct 2026: "300 ml + 250 ml serum" (the full-size serum, once plain "300 ml") still counts as the core single size. */
    [300, 250, 500].some(function (k) { return (cur = ok.filter(function (v) { var m = mls(String(v.t || '').replace(/\s*\+\s*250 ?ml serum\s*$/i, '')); return m.length === 1 && m[0] === k; })[0]); });
    cur = cur || ok.filter(function (v) { var m = mls(v.t); return m.length > 1 && m.every(function (x) { return x > 100 && x < 1000; }); })[0];
    cur = cur || ok[0];
    var g = el('div', 'tss__sizes'), save = el('span', 'tss__save'), add = el('button', 'tc-product-card__quick-add-btn tc-product-card__quick-add-btn--add tss__add', 'Add to cart');
    g.setAttribute('role', 'radiogroup');
    g.setAttribute('aria-label', 'Size');
    add.type = 'button';
    var btns = vs.map(function (v) {
      var b = el('button', 'tss__size', short(v.t));
      b.type = 'button';
      b.setAttribute('role', 'radio');
      b.addEventListener('click', function () { pick(v, 1); });
      return g.appendChild(b);
    });
    function pick(v, user) {
      cur = v;
      btns.forEach(function (b, k) { b.setAttribute('aria-checked', String(vs[k] === v)); b.tabIndex = vs[k] === v ? 0 : -1; });
      price.textContent = v.f;
      photo(v);
      var href = d.u + '?variant=' + v.i;
      if (media) media.setAttribute('href', href);
      if (titleA) titleA.setAttribute('href', href);
      save.textContent = v.d ? 'Save ' + v.d : '';
      save.hidden = !v.d;
      add.setAttribute('data-quick-add', String(v.i));
      /* Design polish round 1, item 19: the name starts with the visible text (WCAG 2.5.3). */
      add.setAttribute('aria-label', 'Add to cart: ' + d.t + ', ' + short(v.t) + ', ' + v.f + (v.d ? ', save ' + v.d + ' against buying separately' : ''));
      if (user) emit({ action: 'size', product: d.t, size: v.t });
    }
    g.addEventListener('keydown', function (e) {
      var dir = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if (!dir) return;
      e.preventDefault();
      var v = ok[(ok.indexOf(cur) + dir + ok.length) % ok.length];
      pick(v, 1);
      btns[vs.indexOf(v)].focus();
    });
    price.parentNode.insertBefore(save, price.nextSibling);
    buy.insertBefore(g, buy.firstChild);
    choose.hidden = true;
    choose.parentNode.insertBefore(add, choose);
    pick(cur);
  }

  function Shelf(root) {
    var tabs = $$(root, '[role=tab]'), live = root.querySelector('[data-tss-live]'), near = 0;
    function panel(t) { return document.getElementById(t.getAttribute('aria-controls')); }
    function refresh(p) {
      var sc = p.querySelector('[data-tc-scroller]');
      if (TC.Scroller && sc) { TC.Scroller.init(p); TC.Scroller.refresh(sc); }
    }
    function lead(p) {
      var tpl = p.querySelector('template[data-tss-lead]');
      if (!tpl || p.hidden || !near) return;
      tpl.parentNode.insertBefore(tpl.content.cloneNode(true), tpl);
      tpl.parentNode.removeChild(tpl);
    }
    function load(t) {
      var p = panel(t), url = t.getAttribute('data-url');
      if (!p || p.hasAttribute('data-loaded')) return Promise.resolve();
      return p.__f || (p.__f = (cache[url] = cache[url] || fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw r.status; return r.text(); }))
        .then(function (html) {
          var items = $$(new DOMParser().parseFromString(html, 'text/html'), '[data-tss-items] > li').slice(0, +t.getAttribute('data-limit') || 8);
          var end = p.querySelector('.tss__end');
          items.forEach(function (li) { end.parentNode.insertBefore(document.importNode(li, true), end); });
          $$(p, '.tc-product-card').forEach(enhance);
        }).catch(function () { delete cache[url]; }).then(function () {
          p.setAttribute('data-loaded', '');
          $$(p, '.tss__ph').forEach(function (x) { x.parentNode.removeChild(x); });
        }));
    }
    function select(t, focus) {
      var p = panel(t), label = t.textContent.trim().toLowerCase();
      tabs.forEach(function (x) {
        x.setAttribute('aria-selected', String(x === t));
        x.tabIndex = x === t ? 0 : -1;
        if (panel(x)) panel(x).hidden = x !== t;
      });
      if (focus) t.focus();
      if (!p) return;
      if (!p.hasAttribute('data-loaded') && !p.querySelector('.tss__ph')) {
        var first = root.querySelector('.tss__panel[data-loaded] .tss__item:not(.tss__end)'), end = p.querySelector('.tss__end');
        for (var i = 0; i < 3; i++) {
          var ph = el('li', 'tss__item tss__ph');
          ph.setAttribute('aria-hidden', 'true');
          if (first) ph.style.setProperty('--tss-ph', first.offsetHeight + 'px');
          end.parentNode.insertBefore(ph, end);
        }
      }
      refresh(p);
      lead(p);
      load(t).then(function () {
        if (live) live.textContent = p.querySelectorAll('.tc-product-card').length + ' ' + label + ' shown';
        refresh(p);
      });
      emit({ action: 'tab', tab: label });
    }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { if (t.getAttribute('aria-selected') !== 'true') select(t); });
      ['pointerenter', 'touchstart', 'focus'].forEach(function (ev) { t.addEventListener(ev, function () { load(t); }, { passive: true }); });
      t.addEventListener('keydown', function (e) {
        var j = { ArrowRight: k + 1, ArrowLeft: k - 1, Home: 0, End: tabs.length - 1 }[e.key];
        if (j === undefined) return;
        e.preventDefault();
        select(tabs[(j + tabs.length) % tabs.length], 1);
      });
    });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-quick-add]'), card = b && b.closest('.tc-product-card');
      if (!card) return;
      var size = card.querySelector('.tss__size[aria-checked=true]');
      pending = { live: live, text: card.querySelector('.tc-product-card__title').textContent.trim() + (size ? ', ' + size.textContent : '') };
      emit({ action: 'add', product: pending.text });
    });
    $$(root, '.tc-product-card').forEach(enhance);
    function go() { near = 1; tabs.forEach(function (t) { if (panel(t)) lead(panel(t)); }); }
    if (!('IntersectionObserver' in window)) return go();
    var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); go(); } }, { rootMargin: '100% 0px' });
    io.observe(root);
  }

  document.addEventListener('cart:updated', function () {
    if (pending && pending.live) pending.live.textContent = 'Added to your basket: ' + pending.text;
    pending = null;
  });
  function init(scope) { $$(scope || document, '[data-tss]').forEach(function (r) { if (!r.__tss) { r.__tss = 1; Shelf(r); } }); }
  TC.SetShelf = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
